import { useEffect, useState } from 'react';
import { api } from '../api';

const emptyForm = { section_code: 'COMPANY', history_date: '', history_content: '' };

export default function HistoryPage() {
  const [sections, setSections] = useState([]);
  const [section, setSection] = useState('COMPANY');
  const [items, setItems] = useState([]);
  const [form, setForm] = useState(emptyForm);
  const [editId, setEditId] = useState(null);

  const load = (code = section) =>
    api.histories.list(code).then(setItems).catch((error) => alert(error.message));

  useEffect(() => {
    api.histories.sections().then(setSections).catch((error) => alert(error.message));
  }, []);

  useEffect(() => { load(section); }, [section]);

  const submit = (event) => {
    event.preventDefault();
    api.histories.save(editId, form)
      .then(() => { setForm({ ...emptyForm, section_code: section }); setEditId(null); load(); })
      .catch((error) => alert(error.response?.data?.message || error.message));
  };

  return (
    <>
      <h2>연혁</h2>
      <div className="row">
        {sections.map((item) => (
          <button key={item.section_code} className={section === item.section_code ? '' : 'ghost'} type="button" onClick={() => setSection(item.section_code)}>
            {item.section_name}
          </button>
        ))}
      </div>
      <form onSubmit={submit}>
        <select value={form.section_code} onChange={(e) => setForm({ ...form, section_code: e.target.value })}>
          {sections.map((item) => <option key={item.section_code} value={item.section_code}>{item.section_name}</option>)}
        </select>
        <input type="date" value={String(form.history_date).slice(0, 10)} onChange={(e) => setForm({ ...form, history_date: e.target.value })} required />
        <textarea placeholder="내용" value={form.history_content} onChange={(e) => setForm({ ...form, history_content: e.target.value })} required />
        <div className="row">
          <button type="submit">{editId ? '수정' : '추가'}</button>
          <button type="button" className="ghost" onClick={() => { setForm({ ...emptyForm, section_code: section }); setEditId(null); }}>취소</button>
        </div>
      </form>
      <table>
        <thead><tr><th>날짜</th><th>내용</th><th></th></tr></thead>
        <tbody>
          {items.map((item) => (
            <tr key={item.history_id}>
              <td>{String(item.history_date).slice(0, 10)}</td>
              <td>{item.history_content}</td>
              <td className="row">
                <button type="button" onClick={() => { setEditId(item.history_id); setForm({ ...item, history_date: String(item.history_date).slice(0, 10) }); }}>수정</button>
                <button type="button" className="danger" onClick={() => window.confirm('삭제할까요?') && api.histories.remove(item.history_id).then(() => load())}>삭제</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}
